import { AxiomReportType } from '@/enums/axiom-report.enum'
import { useAppSelector } from '@/hooks/use-app-selector'
import { IRvAttributionBySectorDTO } from '@/interfaces/rvReport.interface'
import { getColumnDetail } from '@/utils/grid-utils/columnUtils'
import { formatNumber } from '@/utils/utils'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import React, { useEffect, useState } from 'react'

export type IRVAttributionBySector = {
  chartData: IRvAttributionBySectorDTO[]
}

export const RVAttributionBySectorChart: React.FC<IRVAttributionBySector> = ({
  chartData,
}) => {
  const layout = useAppSelector((s) => s.verticallySplitLayout?.contentFocus)

  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: 'column',
      height: 400,
    },
    title: {
      text: undefined,
    },
    xAxis: {
      labels: {
        autoRotation: [0, -45, -90],
      },
    },
    yAxis: [
      {
        title: {
          text: 'Management Effect',
        },
        lineWidth: 1,
        tickWidth: 1,
      },
    ],
    legend: {
      align: 'right',
      verticalAlign: 'top',
      layout: 'vertical',
      itemMarginTop: 5,
      itemMarginBottom: 5,
    },
    series: [],
    credits: {
      enabled: false,
    },
  })

  useEffect(() => {
    const allocationData = {
      name: getColumnDetail('allocation_low1', AxiomReportType.RV).header,
      data: [] as number[],
    }
    const selectionData = {
      name: getColumnDetail('selection_effect1', AxiomReportType.RV).header,
      data: [] as number[],
    }
    const currencyData = {
      name: getColumnDetail('active_currency_return1', AxiomReportType.RV)
        .header,
      data: [] as number[],
    }
    const categories: string[] = []

    chartData &&
      chartData.length &&
      chartData.map((data: IRvAttributionBySectorDTO) => {
        allocationData.data.push(Number(formatNumber(data.allocation_low1)))
        selectionData.data.push(Number(formatNumber(data.selection_effect1)))
        currencyData.data.push(
          Number(formatNumber(data.active_currency_return1)),
        )
        categories.push(data.group1)
      })

    const updatedChartOptions: any = { ...chartOptions }
    updatedChartOptions.xAxis = { categories: categories }
    updatedChartOptions.series[0] = allocationData
    updatedChartOptions.series[1] = selectionData
    updatedChartOptions.series[2] = currencyData
    setChartOptions(updatedChartOptions)
  }, [chartData])

  useEffect(() => {
    const chartHeight = layout?.isTopExpanded ? 640 : 400
    setChartOptions((prevChartOptions) => ({
      ...prevChartOptions,
      chart: {
        ...prevChartOptions.chart,
        height: chartHeight,
      },
    }))
  }, [layout])

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />
}
